<!--计划外配件待申请配件入库用弹窗-->
<template>
  <el-dialog :title="title" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height" style="display:flex">
          <div class="table_main" style="height: 350px!important;">
            <div class="form_class">
              <vxe-form style="background-color: #f6f8fb;">
                <vxe-form-item title="产品编码">
                  <template>
                    <vxe-input v-model="formData.itemCode" :clearable="true" type="text"/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="产品名称">
                  <template>
                    <vxe-input v-model="formData.itemName" :clearable="true" type="text"/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="产品分类:" span="6">
                  <template v-slot>
                      <el-select v-model="formData.bigCategoryId" placeholder="大类"
                                 @change='productSelectOne' style="width: 50%!important;">
                        <el-option v-for="item in productOptions0" :key="item.value"
                                   :label="item.label" :value="item.value" clearable >
                        </el-option>
                      </el-select>
                      <el-select v-model="formData.smallCategoryId" placeholder="小类"
                                 style="width: 49%!important;margin-left:1%;">
                        <el-option v-for="item in productOptions1" :key="item.value"
                                   :label="item.label" :value="item.value" clearable >
                        </el-option>
                      </el-select>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="长*宽*高:" span="6" align="left">
                  <template v-slot>
                    &nbsp;<el-input v-model="formData.length" size="small" clearable
                                    style="width: 4vw!important;" />
                    &nbsp;*&nbsp;<el-input v-model="formData.width" size="small" clearable
                                           style="width: 4vw!important;" />
                    &nbsp;*&nbsp;<el-input v-model="formData.height" size="small" clearable
                                           style="width: 4vw!important;" />
                  </template>
                </vxe-form-item>
                <vxe-form-item title="价差">
                  <template v-slot>
                    <el-input v-model="diffBegin" class="priceInput" style="width: 4vw" :disabled="salePrice==0" clearable/>
                    <span
                        style="display: inline-block;width:1vw;text-align: center;">-</span>
                    <el-input
                        v-model="diffEnd" class="priceInput" ref="prodEnd" style="width:4vw;" :disabled="salePrice==0"  clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="出库仓:" span="6">
                  <template v-slot>
                    <el-select v-model="outWarehouseId" filterable="true" >
                      <el-option v-for="item in outWarehouseList" @click="searchEvent"
                                 :key="item.id"
                                 :label="item.warehouseName + '(' + item.warehouseCode + ')'"
                                 :value="item.id">
                      </el-option>
                    </el-select>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="工厂:" span="6">
                  <template v-slot>
                    <el-select v-model="factory" filterable="true" >
                        <el-option :value="1000" label="总部"></el-option>
                        <el-option :value="1200" label="新工厂"></el-option>
                    </el-select>
                  </template>
                </vxe-form-item>

              </vxe-form>
              <div class="clearfix screen-btns">
                <div class="fr" style="display: inline-block; float: right; margin-top: -39px;">
                  <vxe-button status="warning" style="height: 26px; margin-top: 7px" icon="el-icon-search"
                              class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
            </div>

            <vxe-table style="margin-top: 5px;"
                       :stripe="true"
                       :header-cell-style="{ height: '36px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', }"
                       :row-config="{ isHover: true, padding: 0, labelField: 'id', keyField: 'id'}"
                       :row-style="{ fontSize: '12px', height: '36px', padding: '0'}"
                       :cell-style="{  height: '36px' }"
                       show-overflow
                       :checkbox-config="{ labelField: '', highlight: false, reserve: true, range: true }"
                       @checkbox-change="xTableChecked"
                       @checkbox-all="xTableChecked"
                       ref="xTable"
                       height="80%"
                       :column-config="{ resizable: true }"
                       :data="xTableData"
            >
              <vxe-column type="checkbox" width="40"/>
              <vxe-column title="产品编码" field="itemCode" width="180"></vxe-column>
              <vxe-column title="产品名称" field="itemName" width="160"></vxe-column>
              <vxe-column title="产品大类" field="bigCategoryName" width="160"></vxe-column>
              <vxe-column field="smallCategoryName" title="产品小类" width="160"></vxe-column>
              <vxe-column field="price" title="差价" width="160">
                <template #default="{ row }">
                  <span v-if="salePrice!=0">{{(Number(salePrice)-Number(row.price)).toFixed(6)}}</span>
                  <span v-if="salePrice==0">/</span>
                </template>
              </vxe-column>
              <vxe-column field="bbb" title="长*宽*高" width="160">
                <template #default="{ row }">
                  <span >{{"" + (row.length?row.length:'') + "*" + (row.width?row.width:'') + "*" + (row.height?row.height:'')}}</span>
                </template>
              </vxe-column>
              <vxe-column field="invQty" title="库存" width="160"></vxe-column>
            </vxe-table>

            <div style="float: left; height: 34px; font-size: 12px">
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </div>

          </div>
        </div>
      </div>
    </template>
    <label id="labBtn" class="transverse">
      <div class="icon">
        <i class="el-icon-more"></i>
        <i class="el-icon-more"></i>
      </div>
    </label>
    <div class="multipleChoice">
      <el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
        <a class="allDel icon-quanbushanchu" @click="clearAllChecked()"></a>
      </el-tooltip>
      <div class="list">
        <div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.id">
          <p>{{ checkRow.itemCode }}</p>
          <a class="el-icon-close" @click="clearChecked(checkRow)"></a>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">

			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="doCommit" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import checkboxTable from "@/mixins/selectDialog/checkboxTable";

export default {
  name: 'checkboxPartsInvDialog',
  props: ['visiable', 'chooseItemParams'],
  mixins: [checkboxTable],
  components: {pager},

  created() {
    // 参数初始化
    this.param = this.chooseItemParams
    this.formData.isFirst = 1
    //根据接口先获取明细的金额
    this.getErpPrice()
    this.loadOutWarehouse()
    this.loadProductOption0()
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      param:{},
      salePrice:0,
      diffBegin:1000,
      diffEnd:1000,
      title: '可换机型',
      total: 0,
      filterText: '',
      data: [],
      pageSizes: [10, 20, 100],
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      outWarehouseId: '',
      factory: 1000,
      outWarehouseList: [],
      productOptions0:[],
      productOptions1:[],
      formData: {
        factory:"",
        searchCount: false,  // 是否分页
        itemCode: "",  // 产品编码
        itemName: "",  // 产品名称
        priceBegin: "", // 开始时间
        priceEnd: "", // 结束时间
        current: 1,  // 当前页面
        size: 10,
        isFirst: 1,
        bigCategoryId: null,
        smallCategoryId: null,
        length: null,
        width: null,
        height: null,
      },
      showDialog: true,
      falseValue: false,

    };
  },


  methods: {
    // flushed() {
    //   this.checkedArray = []
    //   this.$refs['table-m1'].commitProxy('reload');
    // },
    loadOutWarehouse() {
      this.$http.get(api.wkExchangeBill.addDataUrl + 'getOutWarehouse', {
      }).then(res => {
        this.outWarehouseList = res.data.data
      })
    },
    productSelectOne() {
      this.productOptions1 = []
      this.searchData.smallCategoryId = null
      this.loadProductOption1()
    },
    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,  // 产品
        // exchangeShow: 1, // 退换货展示为是
        // usable: 1  // 加载启用的
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },

    // 加载产品小类
    loadProductOption1() {
      if (this.searchData.bigCategoryId === ''
        || this.searchData.bigCategoryId === null
        || this.searchData.bigCategoryId === undefined) {
        this.productOptions1 = []
      } else {
        fetchTree({
          categoryType: 1,  // 产品
          // usable: 1,  // 加载启用的
          parentId: this.searchData.bigCategoryId
        }).then(response => {
          this.productOptions1 = []
          response.data.data.forEach(item => {
            this.productOptions1.push({
              label: item.categoryName,
              value: item.id
            })
          })
        })
      }
    },
    getErpPrice(){
      this.$mask.open()
      this.$http({
        url: api.wkExchangeOrder.getErpPriceUrl,
        method: 'post',
        data: this.param,
        isLoading: true,
      }).then(response => {
          this.$mask.close()
          if (response.data.code === 0){
            this.salePrice = response.data.data.salePrice!=null?response.data.data.salePrice:0
          }
      })
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.getTableData();
    },


    // 搜索
    searchEvent() {
      // if (!this.outWarehouseId) {
      //   this.$message.error('请选择出库仓')
      //   return false;
      // }
      this.formData.isFirst = 2
      if (this.diffBegin + this.salePrice!=0){
        this.formData.priceBegin = Number(this.diffBegin) + Number(this.salePrice);
      }else{
        this.formData.priceBegin = null;
      }
      if (this.diffEnd + this.salePrice!=0){
        this.formData.priceEnd = Number(this.diffEnd) + Number(this.salePrice);
      }else {
        this.formData.priceEnd = null;
      }
      // this.formData.priceBegin = this.diffBegin + this.salePrice;
      // this.formData.priceEnd = this.diffEnd + this.salePrice;
      this.formData.outWarehouseId = this.outWarehouseId;
      this.formData.factory = this.factory
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.getTableData()
    },


    doCommit(){
      if (this.checkRows && this.checkRows.length > 0) {
        let exchangeOrderBackDTOS = []
        this.checkRows.forEach(item => {
          exchangeOrderBackDTOS.push({itemId:item.itemId,itemCode:item.itemCode,itemName:item.itemName,
            bigCategoryId:item.bigCategoryId,bigCategoryName:item.bigCategoryName,smallCategoryId:item.smallCategoryId,smallCategoryName:item.smallCategoryName,
            price:item.price
          })
        })
        if (!this.outWarehouseId) {
          this.$message.error("请选择出库仓");
          return false;
        }
        if (!this.factory) {
          this.$message.error("请选择工厂");
          return false;
        }
        let param = {id:this.chooseItemParams.id,outWarehouseId:this.outWarehouseId,factory:this.factory,exchangeOrderBackDTOS:exchangeOrderBackDTOS}
          this.$baseConfirm('您确定要提交吗？').then(() => {
            this.$mask.open()
            this.$http({
              url: api.wkExchangeOrder.chooseItemDataUrl,
              method: 'post',
              data: param,
              isLoading: true,
            }).then(response => {
              this.$mask.close()
              this.$message({
                type: response.data.type,
                message: response.data.content
              });
              this.$emit('commit', true);
          }).catch(() => {
              this.$message.error("操作失败！");
              this.$mask.close()
            });
        })
      }
      },

    getTableData() {
      console.log("this.formData------------",this.formData)
      if (!this.outWarehouseId) {
        return false;
      }
      this.$mask.open()
      this.$http({
        url: api.basItemPrice.getItemPriceUrl,
        method: 'get',
        params: this.formData,
        isLoading: true,
      }).then(res => {
        this.total = res.data.data.total
        this.xTableData = res.data.data.records
        this.$mask.close()
      })
    },

dialogClose(){
  this.$emit('commit', false);
}

  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep body .dialog-style.list-dialog .el-dialog__body {
  background: #F1F5FB;
  padding: 8px 0px 1px !important;
  height: 575px;
}

// ::v-deep .grid-height {
// 	height: calc(100vh - 270px) !important;
// }
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -40px !important;
  position: absolute !important;
  z-index: 9;
  background-color: #ffffff;
}

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

  z-index: 99999;
}

::v-deep .vxe-form--wrapper .vxe-row {
  background-color: #f6f8fb;
}

::v-deep .vxe-form--item {
  font-size: 12px;
  padding: 0;
  margin-left: 7px;
  margin-right: 7px;
}

::v-deep .vxe-pager {
  height: 30px;
}
</style>


